import Axios from "axios";
import { ApiBaseUrl, Supplier } from "../config/config";
import { ApiResultModel } from "../models/common.model";
import {
  Filter,
  getGroupedSalesResponse,
  getSalesByCustomerSearchRequest,
  IAwaitedFactorSalesResponse,
  IcustomerInfo,
  openSaleResponse,
  SaleSearachResponse,
  walletInfoResponse,
} from "../models/supplier.model";

export const GetWalletInfo = (): Promise<walletInfoResponse> => {
  return Axios.post<ApiResultModel<walletInfoResponse>>(
    ApiBaseUrl + Supplier + "/GetWalletInfo"
  ).then((result) => {
    return result.data.data;
  });
};
export const GetGroupedSales = (
  data: getSalesByCustomerSearchRequest
): Promise<ApiResultModel<getGroupedSalesResponse>> => {
  return Axios.post<ApiResultModel<getGroupedSalesResponse>>(
    ApiBaseUrl + Supplier + "/GetGroupedSales",
    data
  ).then((result) => {
    return result.data;
  });
};

export const GetGroupedSalesByBranchExcel = async (data: Filter) => {
  return await Axios({
    method: "POST",
    url: ApiBaseUrl + Supplier + "/GetGroupedSalesByBranchExcel",
    data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
  }).then((response: any) => {
    response = response.data;
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", ` در انتظار بارگذاری فاکتور.xlsx`);
    document.body.appendChild(link);
    link.click();
  });
};
export const GetGroupedSalesByIbanExcel = async (data: Filter) => {
  return await Axios({
    method: "POST",
    url: ApiBaseUrl + Supplier + "/GetGroupedSalesByIbanExcel",
    data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
  }).then((response: any) => {
    response = response.data;
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", ` در انتظار بارگذاری فاکتور.xlsx`);
    document.body.appendChild(link);
    link.click();
  });
};

export const GetSalesByCustomerSearch = (
  data: getSalesByCustomerSearchRequest
): Promise<ApiResultModel<IcustomerInfo[]>> => {
  return Axios.post<ApiResultModel<IcustomerInfo[]>>(
    ApiBaseUrl + Supplier + "/GetSalesByCustomerSearch",
    data
  ).then((result) => {
    return result.data;
  });
};
export const GetSalesByCustomerSearchExcel = async (data: Filter) => {
  return await Axios({
    method: "POST",
    url: ApiBaseUrl + Supplier + "/GetSalesByCustomerSearchExcel",
    data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
  }).then((response: any) => {
    response = response.data;
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", ` در انتظار بارگذاری فاکتور.xlsx`);
    document.body.appendChild(link);
    link.click();
  });
};

export const GetAwaitedFactorSales = (
  data: getSalesByCustomerSearchRequest
): Promise<ApiResultModel<IAwaitedFactorSalesResponse[]>> => {
  return Axios.post<ApiResultModel<IAwaitedFactorSalesResponse[]>>(
    ApiBaseUrl + Supplier + "/GetAwaitedFactorSales",
    data
  ).then((result) => {
    return result.data;
  });
};

export const GetAwaitedFactorSalesReportExcel = async (data: Filter) => {
  return await Axios({
    method: "POST",
    url: ApiBaseUrl + Supplier + "/GetAwaitedFactorSalesReportExcel",
    data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
  }).then((response: any) => {
    response = response.data;
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", ` در انتظار بارگذاری فاکتور.xlsx`);

    document.body.appendChild(link);
    link.click();
  });
};
export const GetWaitForFactorSales = (
  data: getSalesByCustomerSearchRequest
): Promise<ApiResultModel<IAwaitedFactorSalesResponse[]>> => {
  return Axios.post<ApiResultModel<IAwaitedFactorSalesResponse[]>>(
    ApiBaseUrl + Supplier + "/GetWaitForFactorSales",
    data
  ).then((result) => {
    return result.data;
  });
};

export const GetWaitForFactorSalesReportExcel = async (data: Filter) => {
  return await Axios({
    method: "POST",
    url: ApiBaseUrl + Supplier + "/GetWaitForFactorSalesReportExcel",
    data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
  }).then((response: any) => {
    response = response.data;
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", ` در انتظار بارگذاری فاکتور.xlsx`);

    document.body.appendChild(link);
    link.click();
  });
};

export const GetAwaitedSettlementSales = (
  data: getSalesByCustomerSearchRequest
): Promise<ApiResultModel<IAwaitedFactorSalesResponse[]>> => {
  return Axios.post<ApiResultModel<IAwaitedFactorSalesResponse[]>>(
    ApiBaseUrl + Supplier + "/GetAwaitedSettlementSales",
    data
  ).then((result) => {
    return result.data;
  });
};

export const GetAwaitedSettlementSalesExcel = async (data: Filter) => {
  return await Axios({
    method: "POST",
    url: ApiBaseUrl + Supplier + "/GetAwaitedSettlementSalesReportExcel",
    data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
  }).then((response: any) => {
    response = response.data;
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", ` در انتظار بارگذاری فاکتور.xlsx`);
    document.body.appendChild(link);
    link.click();
  });
};

export const GetSalesSearch = (
  data: getSalesByCustomerSearchRequest
): Promise<ApiResultModel<SaleSearachResponse[]>> => {
  return Axios.post<ApiResultModel<SaleSearachResponse[]>>(
    ApiBaseUrl + Supplier + "/GetSalesSearch",
    data
  ).then((result) => {
    return result.data;
  });
};

export const GetSalesSearchExcel = async (data: Filter) => {
  return await Axios({
    method: "POST",
    url: ApiBaseUrl + Supplier + "/GetSalesSearchExcel",
    data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
  }).then((response: any) => {
    response = response.data;
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", ` در انتظار بارگذاری فاکتور.xlsx`);

    document.body.appendChild(link);
    link.click();
  });
};

export const GetOpenSales = (
  data: getSalesByCustomerSearchRequest
): Promise<ApiResultModel<openSaleResponse[]>> => {
  return Axios.post<ApiResultModel<openSaleResponse[]>>(
    ApiBaseUrl + Supplier + "/GetOpenSales",
    data
  ).then((result) => {
    return result.data;
  });
};

export const GetOpenSalesReportExcel = async (data: Filter) => {
  return await Axios({
    method: "POST",
    url: ApiBaseUrl + Supplier + "/GetOpenSalesReportExcel",
    data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
  }).then((response: any) => {
    response = response.data;
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", ` در انتظار بارگذاری فاکتور.xlsx`);

    document.body.appendChild(link);
    link.click();
  });
};
